/**
 * Formats a notification count for display.
 * - Under 1000: shows exact number (e.g., "999")
 * - 1000-9999: shows abbreviated with one decimal if needed (e.g., "1k", "1.3k")
 * - 10000-99999: shows whole thousands (e.g., "16k", "99k")
 * - 100000+: shows "99k+"
 */
export function formatNotificationCount(count: number): string {
  if (count < 1000) {
    return count.toString();
  }
  if (count >= 100_000) {
    return "99k+";
  }
  if (count >= 10_000) {
    return `${Math.floor(count / 1000)}k`;
  }
  const thousands = count / 1000;
  if (count % 1000 === 0) {
    return `${thousands}k`;
  }
  return `${thousands.toFixed(1)}k`;
}
